import HttpClient from "../../client/httpclient";
import { paginatedContent } from "../../paginated-content";
import PaginatedData from "../../client/PaginatedData";
import HashCheckToScroll from "../../helper/hash-check-to-scroll";
import "regenerator-runtime/runtime";

class MobileFilter {
    constructor(DOMelement) {
        try {
            this.el = DOMelement;
            this.areas = [];
            this.types = [];
            this.grades = [];
            this.themes = [];
            this.levels = [];
            this.activityLevels = [];
            this.travelConsultants = [];
            this.destinations = [];
            this.durations = [];
            this.familys = [];
            this.paginatedContent = paginatedContent;
            this.mobileFilterMenu = document.querySelector(".mobile-filter-menu");
            this.hotelFilterButton = document.getElementById("hotelFilterButton");
            this.exitFilterButton = document.querySelector("#exit-close__filter");
            this.checkboxes = this.mobileFilterMenu.querySelectorAll(".sd-checkbox > .sd-checkbox__input");
            this.tabFilterProperties = document.querySelector(".tab-properties");
            this.currentUrl = new URL(window.location.href);
            this.keywordSearchPage = document.querySelector(".keyword-search-filter > .on-site-filter");

            this.tabsContainer = document.getElementById('tabs-container-for-select');

            this.tabItems = document.querySelectorAll(".sd-tabs > ul.tabs >.tab");
            this.numberOfResultsAfterFiltersApplied;


            if (this.tabItems.length > 1) {
                this.containerArea = this.tabFilterProperties.querySelector("#mobile-selected-area");
                this.containerType = this.tabFilterProperties.querySelector("#mobile-selected-type");
                this.containerGrade = this.tabFilterProperties.querySelector("#mobile-selected-grad");
                this.containerTheme = this.tabFilterProperties.querySelector("#mobile-selected-theme");
                this.containerLevel = this.tabFilterProperties.querySelector("#mobile-selected-level");
                this.containerActivityLevel = this.tabFilterProperties.querySelector("#mobile-selected-activity-level");
                this.containerTravelConsultant = this.tabFilterProperties.querySelector("#mobile-selected-travel-consultant");
                this.containerDestination = this.tabFilterProperties.querySelector("#mobile-selected-destination");
                this.containerDuration = this.tabFilterProperties.querySelector("#mobile-selected-duration");
                this.containerFamily = this.tabFilterProperties.querySelector("#mobile-selected-family");
            } else {
                this.containerArea = document.querySelector("#mobile-selected-area");
                this.containerType = document.querySelector("#mobile-selected-type");
                this.containerGrade = document.querySelector("#mobile-selected-grad");
                this.containerTheme = document.querySelector("#mobile-selected-theme");
                this.containerLevel = document.querySelector("#mobile-selected-level");
                this.containerActivityLevel = document.querySelector("#mobile-selected-activity-level");
                this.containerTravelConsultant = document.querySelector("#mobile-selected-travel-consultant");
                this.containerDestination = document.querySelector("#mobile-selected-destination");
                this.containerDuration = document.querySelector("#mobile-selected-duration");
                this.containerFamily = document.querySelector("#mobile-selected-family");
            }

            this.filterButtonArea = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.area-dd");
            this.filterButtonType = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.type-dd");
            this.filterButtonGrade = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.grade-dd");
            this.filterButtonTheme = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.theme-dd");
            this.filterButtonLevel = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.activity-level-dd");
            this.filterButtonDestination = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.destination-dd");
            this.filterButtonTravelConsultant = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.travel-consultant-dd");
            this.filterButtonDuration = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.duration-dd");
            this.filterButtonFamily = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.family-dd");

            this.applyButton = document.getElementById("mobile-apply__filter");
            this.url = this.applyButton.getAttribute("data-action");
            this.method = "GET";
            this.itemId = this.applyButton.getAttribute("data-item");

            this.filterOptions = document.querySelectorAll(".sd-mobile-filter-item-title");
            this.bindButtons(this.filterOptions);

            const toggleFilterMenu = () => {
                this.toggleMobileFilterMenu();
            };

            this.hotelFilterButton.addEventListener("click", toggleFilterMenu);
            this.exitFilterButton.addEventListener("click", toggleFilterMenu);


            this.getElementsAndSetData();

            if (process.env.NODE_ENV === "development") {
                this.url = "/src/api/product-search-result.json";
            }

            this.grabFilters = this.grabFilters.bind(this);
            this.appendFilter = this.appendFilter.bind(this);
            this.appendFilterByType = this.appendFilterByType.bind(this);
            this.appendFilterByAreas = this.appendFilterByAreas.bind(this);
            this.appendFilterByGrades = this.appendFilterByGrades.bind(this);
            this.appendFilterByThemes = this.appendFilterByThemes.bind(this);
            this.appendFilterByLevels = this.appendFilterByLevels.bind(this);
            this.appendFilterByActivityLevels = this.appendFilterByActivityLevels.bind(this);
            this.appendFilterByTravelConsultants = this.appendFilterByTravelConsultants.bind(this);
            this.appendFilterByDestinations = this.appendFilterByDestinations.bind(this);
            this.appendFilterByDurations = this.appendFilterByDurations.bind(this);
            this.appendFilterByFamilys = this.appendFilterByFamilys.bind(this);
            this.removeFilter = this.removeFilter.bind(this);
            this.applyFilter = this.applyFilter.bind(this);
            this.toggleMobileFilterMenu = this.toggleMobileFilterMenu.bind(this);

            // Initialize checkboxes and set up event listeners
            this.filterHandlers = {
                "by-type": this.appendFilterByType,
                "by-area": this.appendFilterByAreas,
                "by-grade": this.appendFilterByGrades,
                "by-theme": this.appendFilterByThemes,
                "by-level": this.appendFilterByLevels,
                "by-activity-level": this.appendFilterByActivityLevels,
                "by-travel-consultant": this.appendFilterByTravelConsultants,
                "by-destination": this.appendFilterByDestinations,
                "by-duration": this.appendFilterByDurations,
                "by-family": this.appendFilterByFamilys
            };

            this.checkboxes = this.mobileFilterMenu.querySelectorAll(".sd-checkbox > .sd-checkbox__input");
            [...this.checkboxes].forEach((checkbox) => {
                checkbox.checked = false;
                const parentClass = checkbox.parentNode.parentNode.classList[0];
                if (this.filterHandlers[parentClass]) {
                    checkbox.addEventListener("change", this.filterHandlers[parentClass]);
                }
            });

            this.applyButton.addEventListener("click", this.applyFilter);
            this.applyButton.addEventListener("click", toggleFilterMenu);


            const radios = document.querySelectorAll("input[type=radio][name=\"css-tabs\"]");

            radios.forEach(radio => {
                radio.addEventListener("click", () => {
                    this.getElementsAndSetData();
                });
            });

            this.reAttachMobileFilterOptions = this.reAttachMobileFilterOptions.bind(this);
            PaginatedData.SetReAttachMobileFilterOptions(this.reAttachMobileFilterOptions);

            if (window.innerWidth < 1024) {
                // we are in the Mobile viewport bucket 
                this.queryParams = new URLSearchParams(window.location.search);
                if (this.queryParams) {
                    this.queryParamsValue = Object.fromEntries(this.queryParams.entries());

                    switch (this.queryParamsValue.t) {
                        case "hotels":
                            this.keywordSearchPage.style.display = "block";
                            break;
                        case "things to do":
                            this.keywordSearchPage.style.display = "block";
                            break;
                        case "tours":
                            this.keywordSearchPage.style.display = "block";
                            break;
                        default:
                            break;
                    }
                }

                this.CheckUrlFilterParams();
                this.GetSelectedTab()
            }


        } catch (error) {
            console.log(error);
        }
    }

    UpdateSelectedFilters() {
        let areas = [];
        let types = [];
        let grades = [];
        let themes = [];
        let levels = [];
        let activityLevels = [];
        let travelConsultants = [];
        let destinations = [];
        let durations = [];
        let familys = [];

        const filterMap = {
            'by-grade': grades,
            'by-type': types,
            'by-area': areas,
            'by-theme': themes,
            'by-level': levels,
            'by-activity-level': activityLevels,
            'by-travel-consultant': travelConsultants,
            'by-destination': destinations,
            'by-duration': durations,
            'by-family': familys,
        };

        //process each checkbox
        this.checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                const classList = checkbox.parentNode.parentNode.classList;

                // Iterate over the filterMap object
                Object.entries(filterMap).forEach(([key, array]) => {
                    if (classList.contains(key)) {
                        array.push({ Title: checkbox.value });
                    }
                });
            }
        });

        this.SetFilterCountSpans(areas.length, types.length, grades.length, themes.length, levels.length, activityLevels.length, travelConsultants.length, destinations.length, durations.length, familys.length,
            areas.length + types.length + grades.length + themes.length + levels.length + activityLevels.length + travelConsultants.length + destinations.length + durations.length + familys.length);

        this.appendFilters(areas, this.containerArea);
        this.appendFilters(types, this.containerType);
        this.appendFilters(grades, this.containerGrade);
        this.appendFilters(themes, this.containerTheme);
        this.appendFilters(levels, this.containerLevel);
        this.appendFilters(activityLevels, this.containerActivityLevel);
        if (this.containerTravelConsultant) {
            this.appendFilters(travelConsultants, this.containerTravelConsultant);
        }
        if (this.containerDestination) {
            this.appendFilters(destinations, this.containerDestination);
        }
        this.appendFilters(durations, this.containerDuration);
        this.appendFilters(familys, this.containerFamily);
    }

    //Method used as a callback for instances of the filter dropdown being generated through JS and losing the eventListeners from the elements.
    //We need to select these new elements returned from the back end in order to be able to use them again.
    //This is used in "SearchFilter.js"
    reAttachMobileFilterOptions() {

        this.toggleMobileFilterMenu = this.toggleMobileFilterMenu.bind(this);
        this.mobileFilterMenu = document.querySelector(".mobile-filter-menu");
        this.el = document.querySelectorAll(".sd-filter-button");

        this.hotelFilterButton = document.querySelector("#hotelFilterButton");
        this.exitFilterButton = document.querySelector("#exit-close__filter");
        this.tabFilterProperties = document.querySelector(".tab-properties");

        //reset the slected filter values in order to re-attach and run this filter functionality as per usual.
        this.areas = [];
        this.types = [];
        this.grades = [];
        this.themes = [];
        this.levels = [];
        this.activityLevels = [];
        this.travelConsultants = [];
        this.destinations = [];
        this.durations = [];
        this.familys = [];

        //Selected filter containers
        this.containerArea = document.querySelector("#mobile-selected-area");
        this.containerType = document.querySelector("#mobile-selected-type");
        this.containerGrade = document.querySelector("#mobile-selected-grad");
        this.containerTheme = document.querySelector("#mobile-selected-theme");
        this.containerLevel = document.querySelector("#mobile-selected-level");
        this.containerActivityLevel = document.querySelector("#mobile-selected-activity-level");
        this.containerTravelConsultant = document.querySelector("#mobile-selected-travel-consultant");
        this.containerDestination = document.querySelector("#mobile-selected-destination");
        this.containerDuration = document.querySelector("#mobile-selected-duration");
        this.containerFamily = document.querySelector("#mobile-selected-family");

        //Dropdowns
        this.filterButtonArea = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.area-dd");
        this.filterButtonType = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.type-dd");
        this.filterButtonGrade = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.grade-dd");
        this.filterButtonTheme = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.theme-dd");
        this.filterButtonLevel = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.level-dd");
        this.filterButtonActivityLevel = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.activity-level-dd");
        this.filterButtonTravelConsultant = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.travel-consultant-dd");
        this.filterButtonDestination = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.destination-dd");
        this.filterButtonDuration = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.duration-dd");
        this.filterButtonFamily = document.querySelector(".sd-mobile-filter-item-title.sd-filter-dd.family-dd");

        this.filterButton = document.querySelectorAll(".sd-filter-dd");

        this.filterButton.forEach((button) => {
            button.addEventListener("click", this.toggleFilter);
        });

        //Checkboxes

        this.applyButton = document.getElementById("mobile-apply__filter");

        this.filterOptions = document.querySelectorAll(".sd-mobile-filter-item-title");
        this.bindButtons(this.filterOptions);

        const toggleFilterMenu = () => {
            this.toggleMobileFilterMenu();
        };

        this.applyButton.addEventListener("click", this.applyFilter);
        this.applyButton.addEventListener("click", toggleFilterMenu);

        this.getElementsAndSetData();

        this.hotelFilterButton.addEventListener("click", toggleFilterMenu);
        this.exitFilterButton.addEventListener("click", toggleFilterMenu);

        this.checkboxes = this.mobileFilterMenu.querySelectorAll(".sd-checkbox > .sd-checkbox__input");
        [...this.checkboxes].forEach((checkbox) => {
            if (checkbox.parentNode.parentNode.classList == "by-type") {
                checkbox.addEventListener("change", this.appendFilterByType);
            } else if (checkbox.parentNode.parentNode.classList == "by-area") {
                checkbox.addEventListener("change", this.appendFilterByAreas);
            } else if (checkbox.parentNode.parentNode.classList == "by-grade") {
                checkbox.addEventListener("change", this.appendFilterByGrades);
            } else if (checkbox.parentNode.parentNode.classList == "by-theme") {
                checkbox.addEventListener("change", this.appendFilterByThemes);
            } else if (checkbox.parentNode.parentNode.classList == "by-level") {
                checkbox.addEventListener("change", this.appendFilterByLevels);
            } else if (checkbox.parentNode.parentNode.classList == "by-activity-level") {
                checkbox.addEventListener("change", this.appendFilterByActivityLevels);
            } else if (checkbox.parentNode.parentNode.classList == "by-travel-consultant") {
                checkbox.addEventListener("change", this.appendFilterByTravelConsultants);
            } else if (checkbox.parentNode.parentNode.classList == "by-destination") {
                checkbox.addEventListener("change", this.appendFilterByDestinations);
            } else if (checkbox.parentNode.parentNode.classList == "by-duration") {
                checkbox.addEventListener("change", this.appendFilterByDurations);
            } else if (checkbox.parentNode.parentNode.classList == "by-family") {
                checkbox.addEventListener("change", this.appendFilterByFamilys);
            }
        });
    }



    async CheckUrlFilterParams() {
        this.areas = [];
        this.grades = [];
        this.types = [];
        this.themes = [];
        this.levels = [];
        this.activityLevels = [];
        this.travelConsultants = [];
        this.destinations = [];
        this.durations = [];
        this.familys = [];

        if (this.queryParamsValue["area"] || this.queryParamsValue["grade"] || this.queryParamsValue["tag"]
            || this.queryParamsValue["theme"] || this.queryParamsValue["level"] || this.queryParamsValue["activitylevel"] || this.queryParamsValue["travelconsultant"] || this.queryParamsValue["destination"]
            || this.queryParamsValue["duration"] || this.queryParamsValue["family"]) {
            if (this.queryParamsValue["area"]) {
                let areaUrlParamsList = this.queryParamsValue["area"].split("|");
                for (var i = 0; i < areaUrlParamsList.length; i++) {
                    this.areas.push({ Title: areaUrlParamsList[i] });
                }
            }
            if (this.queryParamsValue["tag"]) {
                let typeUrlParamsList = this.queryParamsValue["tag"].split("|");
                for (var i = 0; i < typeUrlParamsList.length; i++) {
                    this.types.push({ Title: typeUrlParamsList[i] });
                }
            }
            if (this.queryParamsValue["grade"]) {
                let gradeUrlParamsList = this.queryParamsValue["grade"].split("|");
                for (var i = 0; i < gradeUrlParamsList.length; i++) {
                    this.grades.push({ Title: gradeUrlParamsList[i] });
                }
            }
            if (this.queryParamsValue["theme"]) {
                let themeUrlParamsList = this.queryParamsValue["theme"].split("|");
                for (var i = 0; i < themeUrlParamsList.length; i++) {
                    this.themes.push({ Title: themeUrlParamsList[i] });
                }
            }
            if (this.queryParamsValue["level"]) {
                let levelUrlParamsList = this.queryParamsValue["level"].split("|");
                for (var i = 0; i < levelUrlParamsList.length; i++) {
                    this.levels.push({ Title: levelUrlParamsList[i] });
                }
            }

            if (this.queryParamsValue["activitylevel"]) {
                let activitylevelUrlParamsList = this.queryParamsValue["activitylevel"].split("|");
                for (var i = 0; i < activitylevelUrlParamsList.length; i++) {
                    this.activityLevels.push({ Title: activitylevelUrlParamsList[i] });
                }
            }
            if (this.queryParamsValue["travelconsultant"]) {
                let travelconsultantUrlParamsList = this.queryParamsValue["travelconsultant"].split("|");
                for (var i = 0; i < travelconsultantUrlParamsList.length; i++) {
                    this.travelconsultants.push({ Title: travelconsultantUrlParamsList[i] });
                }
            }
            if (this.queryParamsValue["destination"]) {
                let destinationUrlParamsList = this.queryParamsValue["destination"].split("|");
                for (var i = 0; i < destinationUrlParamsList.length; i++) {
                    this.destinations.push({ Title: destinationUrlParamsList[i] });
                }
            }

            if (this.queryParamsValue["duration"]) {
                let durationUrlParamsList = this.queryParamsValue["duration"].split("|");
                for (var i = 0; i < durationUrlParamsList.length; i++) {
                    this.durations.push({ Title: durationUrlParamsList[i] });
                }
            }

            if (this.queryParamsValue["family"]) {
                let familyUrlParamsList = this.queryParamsValue["family"].split("|");
                for (var i = 0; i < familyUrlParamsList.length; i++) {
                    this.familys.push({ Title: familyUrlParamsList[i] });
                }
            }
            if (this.queryParamsValue["t"]) {
                var urlCategory = this.queryParamsValue["t"];
                this.SetFilterTabCategoryFromURL(urlCategory);
            }

            var currentPage = 1;
            if (this.queryParamsValue["page"]) {
                currentPage = this.queryParamsValue["page"];
            }

            this.FetchSelectedFilterFromUrlParams();

            const data = {
                pageid: this.itemId,
                page: currentPage,
                currenturl: location.href.toLowerCase(),
                areas: this.areas,
                tags: this.types,
                tab: PaginatedData.getTab(),
                grades: this.grades,
                themes: this.themes,
                levels: this.levels,
                activityLevels: this.activityLevels,
                travelConsultants: this.travelConsultants,
                destinations: this.destinations,
                durations: this.durations,
                familys: this.familys,
                filter: PaginatedData.getFilter(),
                q: PaginatedData.getURLqueryString(),
                category: PaginatedData.getOnsiteSearchCategory(),
            };

            this.AddUrlFilterParams(data);

            if (process.env.NODE_ENV === "development") {
                const url = `${this.url}?data=${encodeURIComponent(JSON.stringify(data))}`;
                await this.getDataFromAPI(url, this.method);
            } else {
                const url = `${this.url}?data=${encodeURIComponent(JSON.stringify(data))}`;
                await this.getDataFromAPI(url, this.method);
            }

        }
    }

    SetFilterTabCategoryFromURL(urlCategory) {
        const selectElement = document.getElementById('multiple-list');
        Array.from(selectElement.options).forEach(function (option) {
            let splitValue = option.value.split("%");
            let category = splitValue[1].toLowerCase();

            option.selected = (category == urlCategory);
        });


        var tabHeaders = this.tabsContainer.querySelectorAll('.tab-header-for-select');
        tabHeaders.forEach(function (tabHeader) {
            var tabHeaderValue = tabHeader.getAttribute("data-value");
            let splitValue = tabHeaderValue.split("%");
            let category = splitValue[1].toLowerCase();
            if (category != urlCategory) {
                tabHeader.classList.remove('active-select');
            } else {
                tabHeader.classList.add('active-select');
            }
        });
    }

    GetSelectedTab() {
        const selectElement = document.getElementById('multiple-list');
        var currentTabFromCategory;

        if (selectElement) {
            const selectedOption = selectElement.options[selectElement.selectedIndex];
            let splitValue = selectedOption.value.split("%");

            PaginatedData.setFilter(splitValue[0]);
            PaginatedData.setOnsiteSearchCategory(splitValue[1].toLowerCase());

            switch (splitValue[1].toLowerCase()) {
                case "hotels":
                    currentTabFromCategory = "properties";
                    break;
                case "tours":
                    currentTabFromCategory = "itineraries";
                    break;
                case "things to do":
                    currentTabFromCategory = "experiences";
                    break;
                default:
                    currentTabFromCategory = splitValue[1].toLowerCase();
                    break;
            }
        }

        return currentTabFromCategory;
    }

    FetchSelectedFilterFromUrlParams() {
        // Fetch the selected tab to request it's required data
        const selectElement = document.getElementById('multiple-list');
        const checkboxes = document.querySelectorAll('.sd-checkbox');
        var currentTabFromCategory;

        if (selectElement) {
            // Find the selected option
            currentTabFromCategory = this.GetSelectedTab();
        } else {
            let findProperty = document.querySelector(".sd-tabs > .tab-properties");
            let findItin = document.querySelector(".sd-tabs > .tab-itineraries");
            let findExp = document.querySelector(".sd-tabs > .tab-experiences");

            if (findProperty) {
                currentTabFromCategory = "properties";
            } else if (findItin) {
                currentTabFromCategory = "itineraries";
            } else if (findExp) {
                currentTabFromCategory = "experiences";
            }
        }

        // Loop through the checkboxes
        checkboxes.forEach(function (checkbox) {
            const value = checkbox.querySelector('.sd-checkbox__input').value.toLowerCase().trim();
            const collections = [
                this.areas, this.grades, this.types, this.themes,
                this.levels, this.durations, this.familys,
                this.activityLevels, this.travelConsultants, this.destinations
            ];

            if (collections.some(collection => collection.some(obj => value.includes(obj.Title.toLowerCase())))) {
                checkbox.querySelector('.sd-checkbox__input').checked = true;
            }
        }.bind(this));


        PaginatedData.setTab(currentTabFromCategory);
        PaginatedData.setSearchflag(true);

        this.UpdateSelectedFilters();
    }

    AddUrlFilterParams(data) {
        var newQueryParams = new URLSearchParams();
        //Add the query and tab to the search query params
        if (this.queryParamsValue && this.queryParamsValue["q"] && this.queryParamsValue["t"]) {
            newQueryParams.append("q", this.queryParamsValue.q);
            newQueryParams.append("t", this.queryParamsValue.t);
        }

        //add any of the filters if there are any selected
        const filterMapping = {
            area: data.areas,
            tag: data.tags,
            grade: data.grades,
            theme: data.themes,
            level: data.levels,
            activitylevel: data.activityLevels,
            travelconsultant: data.travelConsultants,
            destination: data.destinations,
            duration: data.durations,
            family: data.familys,
        };

        Object.keys(filterMapping).forEach(key => {
            if (filterMapping[key].length > 0) {
                newQueryParams.append(key, this.BuildFilterParamString(filterMapping[key]));
            }
        });

        if (data.page > 1) {
            newQueryParams.append("page", data.page);
        }

        //grab a hash if there is one (this is for auto-scrolling when being redirected eg. #tours or #best-time-to-visit)
        var hash = new URL(data.currenturl).hash;
        if (hash) {
            new HashCheckToScroll(hash);
        } else {
            hash = "";
        }

        //Set the current url without reloading the screen
        const newUrl = `${this.currentUrl.origin}${this.currentUrl.pathname}?${newQueryParams}${hash}`;
        history.pushState({ path: newUrl }, null, newUrl);
    }

    //builds a string with the listed items being filtered, This comma separates the items in the list to make a single string
    BuildFilterParamString(dataItems) {
        return dataItems.map(item => item.Title).join('|');
    }

    //the only way to enforce this popup loads correctly on mobile IOS is to force a scroll.
    toggleMobileFilterMenu() {
        this.mobileFilterMenu.classList.toggle("active");
        this.exitFilterButton.classList.toggle("active");

    }

    bindButtons(buttons) {
        for (let i = 0; i < buttons.length; i++) {
            buttons[i].addEventListener("click", function () {
                if (this.classList.contains("activeFilter")) {
                    // If the clicked element is already active, deactivate it
                    this.classList.remove("activeFilter");
                    var filter = this.nextElementSibling;
                    filter.style.maxHeight = null;
                } else {
                    // Deactivate all elements
                    for (let j = 0; j < buttons.length; j++) {
                        buttons[j].classList.remove("activeFilter");
                        var filter = buttons[j].nextElementSibling;
                        filter.style.maxHeight = null;
                    }

                    // Activate the clicked element
                    this.classList.add("activeFilter");
                    var filter = this.nextElementSibling;
                    filter.style.maxHeight = filter.scrollHeight + "px";
                }
            });
        }
    }

    getElementsAndSetData() {
        this.currentTab = PaginatedData.getTab();
        this.contentEl = document.querySelector(".tab-" + this.currentTab);
        this.result = document.getElementsByClassName("sd-pagination-content")[0];
        this.pagination = document.querySelector(".pager-" + this.currentTab);
    }

    // Method to grab filter data based on the type and class name
    grabFilters(filterType, className) {
        const filterList = [];
        this.checkboxes.forEach((checkbox) => {
            if (checkbox.checked && checkbox.parentNode.parentNode.classList.contains(className)) {
                filterList.push({ Title: checkbox.value });
            }
        });

        // Update the PaginatedData based on the filter type
        switch (filterType) {
            case 'type': PaginatedData.setSelectedTags(filterList); break;
            case 'grade': PaginatedData.setSelectedGrades(filterList); break;
            case 'area': PaginatedData.setSelectedAreas(filterList); break;
            case 'theme': PaginatedData.setSelectedThemes(filterList); break;
            case 'level': PaginatedData.setSelectedLevels(filterList); break;
            case 'activity-level': PaginatedData.setSelectedActivityLevels(filterList); break;
            case 'travel-consultant': PaginatedData.setSelectedTravelConsultants(filterList); break;
            case 'destination': PaginatedData.setSelectedDestinations(filterList); break;
            case 'duration': PaginatedData.setSelectedDurations(filterList); break;
            case 'family': PaginatedData.setSelectedFamilys(filterList); break;
        }

        // Return the filtered list
        return filterList;
    }
    // Method to append filters to a container
    appendFilter(filterType, container) {
        const filters = this.grabFilters(filterType, `by-${filterType}`);
        container.innerHTML = "";
        this.appendFilters(filters, container);
    }

    // Methods to append filters to specific containers
    appendFilterByType() {
        this.appendFilter('type', this.containerType);
    }

    appendFilterByAreas() {
        this.appendFilter('area', this.containerArea);
    }

    appendFilterByGrades() {
        this.appendFilter('grade', this.containerGrade);
    }

    appendFilterByThemes() {
        this.appendFilter('theme', this.containerTheme);
    }

    appendFilterByLevels() {
        this.appendFilter('level', this.containerLevel);
    }

    appendFilterByActivityLevels() {
        this.appendFilter('activity-level', this.containerActivityLevel);
    }
    appendFilterByTravelConsultants() {
        if (this.containerTravelConsultant) {
            this.appendFilter('travel-consultant', this.containerTravelConsultant);
        }
    }
    appendFilterByDestinations() {
        if (this.containerDestination) {
            this.appendFilter('destination', this.containerDestination);
        }
        this.appendFilter('destination', this.containerDestination);
    }

    appendFilterByDurations() {
        this.appendFilter('duration', this.containerDuration);
    }

    appendFilterByFamilys() {
        this.appendFilter('family', this.containerFamily);
    }

    // Method to append filters to a node
    appendFilters(data, node) {
        data.forEach((value) => {
            const label = document.createElement("label");
            const span = document.createElement("span");
            span.innerHTML = "X";
            span.classList.add("removeFilterClose");
            label.setAttribute("for", value.Title);
            const textNode = document.createTextNode(value.Title);
            label.appendChild(textNode);
            label.appendChild(span);
            node.append(label);
            span.addEventListener("click", this.removeFilter);
        });

        // Update filter counts
        this.SetFilterCountSpans(
            this.grabFilters('area', 'by-area').length,
            this.grabFilters('type', 'by-type').length,
            this.grabFilters('grade', 'by-grade').length,
            this.grabFilters('theme', 'by-theme').length,
            this.grabFilters('level', 'by-level').length,
            this.grabFilters('activity-level', 'by-activity-level').length,
            this.grabFilters('travel-consultant', 'by-travel-consultant').length,
            this.grabFilters('destination', 'by-destination').length,
            this.grabFilters('duration', 'by-duration').length,
            this.grabFilters('family', 'by-family').length,
            this.grabFilters('area', 'by-area').length +
            this.grabFilters('type', 'by-type').length +
            this.grabFilters('grade', 'by-grade').length +
            this.grabFilters('theme', 'by-theme').length +
            this.grabFilters('level', 'by-level').length +
            this.grabFilters('activity-level', 'by-activity-level').length +
            this.grabFilters('travel-consultant', 'by-travel-consultant').length +
            this.grabFilters('destination', 'by-destination').length +
            this.grabFilters('duration', 'by-duration').length +
            this.grabFilters('family', 'by-family').length
        );
    }


    async getDataFromAPI(url, method) {

        this.getElementsAndSetData();
        this.currentTab = PaginatedData.getTab();
        let resultCountDiv;
        if (this.currentTab !== "") {
            resultCountDiv = this.contentEl.querySelector(`.pager-${this.currentTab}`) ?? document.querySelector(`.pager-${this.currentTab}`);
        }
        let paginationData;

        //retrieve the contentID to only update the correct tabs fields. This prevents filters of 1 tab affecting results/pagination of other tabs.
        var contentId;

        await HttpClient.AsyncGetRequest(url, method)
            .then(result => {
                let data = JSON.parse(result);
                this.currentTab = PaginatedData.getTab();
                this.numberOfResultsAfterFiltersApplied = data.totalresults;

                if (data.totalpages == 0) {
                    if (this.result && data.filterOptions == null) {
                        this.result.innerHTML = "<div class='sd-body1' style='padding:20px 0;'>" + "No results found. Try removing filters to show results." + "</div>";
                    } else {
                        paginationData = document.querySelector(".sd-pagination-content");
                        let resultsPage = paginationData.querySelector(".result-page-tab");
                        resultsPage.innerHTML = "<div class='sd-body1' style='padding:20px 0;'>" + "No results found. Try removing filters to show results." + "</div>";
                    }
                    this.contentEl.classList.add("no-results");
                    resultCountDiv.parentElement.style.display = 'none';
                } else {
                    if (this.result && data.filterOptions == null) {
                        this.result.innerHTML = "";
                        this.result.insertAdjacentHTML("beforeend", data.result);

                        var searchSettings = JSON.parse(data.searchSettings);
                        const observer = lozad();
                        observer.observe();
                        //retrieve the contentID to only update the correct tabs fields. This prevents filters of 1 tab affecting results/pagination of other tabs.
                        contentId = resultCountDiv.getAttribute("data-pagination-id");
 
                        const itemsPerPageElement = document.querySelector('[data-itemsperpage]');
                        let itemsPerPage = 0;
                        if (itemsPerPageElement != null) {
                            itemsPerPage = parseInt(itemsPerPageElement.getAttribute('data-itemsperpage'));
                        }

                        this.pagination && this.pagination.setAttribute("data-totalpages", data.totalpages);
                        resultCountDiv.parentElement.style.display = '';
                        this.pagination && this.pagination.setAttribute("data-totalresults", data.totalresults);
                        this.pagination && this.pagination.setAttribute("data-resulttype", data.resulttype);

                        this.pagination = document.querySelector(".pager-" + this.currentTab);

                        this.pagination && this.pagination.setAttribute("data-current-page-no", searchSettings.Page);
                        const currentPageNo = searchSettings.Page;

                        //Run callback to update the pagination navigation
                        PaginatedData.updatePagination(searchSettings.Page, itemsPerPage, data.totalpages, data.resulttype);
                        PaginatedData.getFilteredResultCount(data.totalresults, data.resulttype, contentId, parseInt(currentPageNo));
                    } else {
                        paginationData = document.querySelector(".sd-pagination-content");
                        paginationData.innerHTML = "";
                        paginationData.insertAdjacentHTML("beforeend", data.result);

                        const observer = lozad();
                        observer.observe();

                        this.UpdateSelectedFilters();
                    }
                    this.contentEl.classList.remove("no-results");
                }
            })
            .catch(error => {
                console.error(error);
            });
    }

    removeFilter(e) {

        const filterLabel = e.target.parentElement;
        const value = filterLabel.htmlFor;

        this.checkboxes.forEach((item) => {
            if (item.value === value) {
                item.checked = false;
            }
        });
        filterLabel.remove();

        // Use the generalized method to grab all filters
        this.areas = this.grabFilters('area', 'by-area');
        this.types = this.grabFilters('type', 'by-type');
        this.grades = this.grabFilters('grade', 'by-grade');
        this.themes = this.grabFilters('theme', 'by-theme');
        this.levels = this.grabFilters('level', 'by-level');
        this.activityLevels = this.grabFilters('activity-level', 'by-activity-level');
        this.travelConsultants = this.grabFilters('travel-consultant', 'by-travel-consultant');
        this.destinations = this.grabFilters('destination', 'by-destination');
        this.durations = this.grabFilters('duration', 'by-duration');
        this.familys = this.grabFilters('family', 'by-family');

        this.SetFilterCountSpans(this.areas.length, this.types.length, this.grades.length, this.themes.length, this.levels.length, this.activityLevels.length, this.travelConsultants.length, this.destinations.length, this.durations.length, this.familys.length,
            this.areas.length + this.types.length + this.grades.length + this.themes.length + this.levels.length + this.activityLevels.length + this.travelConsultants.length + this.destinations.length + this.durations.length + this.familys.length);
        this.applyFilter();
    }

    //Update the filter field elements to contain the count of filters per type of filter (area, type and grade) eg. area has Paris selected therefore we show a count of 1 in the dropdown.
    SetFilterCountSpans(totalAreas, totalTypes, totalGrades, totalThemes, totalLevels, totalActivityLevels, totalTravelConsultants, totalDestinations, totalDurations, totalFamilys, totalFilters) {
        const filterMapping = [
            { count: totalAreas, selector: ".sd-mobile-filter-item-title.sd-filter-dd.area-dd > span", button: this.filterButtonArea },
            { count: totalTypes, selector: ".sd-mobile-filter-item-title.sd-filter-dd.type-dd > span", button: this.filterButtonType },
            { count: totalGrades, selector: ".sd-mobile-filter-item-title.sd-filter-dd.grade-dd > span", button: this.filterButtonGrade },
            { count: totalThemes, selector: ".sd-mobile-filter-item-title.sd-filter-dd.theme-dd > span", button: this.filterButtonTheme },
            { count: totalLevels, selector: ".sd-mobile-filter-item-title.sd-filter-dd.level-dd > span", button: this.filterButtonLevel },
            { count: totalActivityLevels, selector: ".sd-mobile-filter-item-title.sd-filter-dd.activity-level-dd > span", button: this.filterButtonActivityLevel },
            { count: totalTravelConsultants, selector: ".sd-mobile-filter-item-title.sd-filter-dd.travel-consultant-dd > span", button: this.filterButtonTravelConsultant },
            { count: totalDestinations, selector: ".sd-mobile-filter-item-title.sd-filter-dd.destination-dd > span", button: this.filterButtonDestination },
            { count: totalDurations, selector: ".sd-mobile-filter-item-title.sd-filter-dd.duration-dd > span", button: this.filterButtonDuration },
            { count: totalFamilys, selector: ".sd-mobile-filter-item-title.sd-filter-dd.family-dd > span", button: this.filterButtonFamily },
        ];

        // Update individual filter counts
        filterMapping.forEach(filter => {
            const element = document.querySelector(filter.selector);
            if (filter.button && element) {
                element.innerHTML = filter.count > 0 ? `<span>${filter.count}</span>` : "";
            }
        });

        // Update total filters count and visibility
        const filterCount = document.querySelector("#hotelFilterButton > #hotelFilterButtonCount");
        const filterIcon = document.querySelector("#hotelFilterButton > #hotelFilterButtonIcon");

        if (filterCount && filterIcon) {
            if (totalFilters > 0) {
                filterCount.innerHTML = `<span>${totalFilters}</span>`;
                if (filterCount.classList.contains("filter-count-hide")) {
                    filterCount.classList.remove("filter-count-hide");
                    filterIcon.classList.add("filter-count-hide");
                }
            } else {
                filterCount.innerHTML = "";
                if (!filterCount.classList.contains("filter-count-hide")) {
                    filterCount.classList.add("filter-count-hide");
                    filterIcon.classList.remove("filter-count-hide");
                }
            }
        }
    }


    async applyFilter(event) {
        // Use the generalized method to grab all filters
        this.areas = this.grabFilters('area', 'by-area');
        this.types = this.grabFilters('type', 'by-type');
        this.grades = this.grabFilters('grade', 'by-grade');
        this.themes = this.grabFilters('theme', 'by-theme');
        this.levels = this.grabFilters('level', 'by-level');
        this.destinations = this.grabFilters('destination', 'by-destination');
        this.activityLevels = this.grabFilters('activity-level', 'by-activity-level');
        this.travelConsultants = this.grabFilters('travel-consultant', 'by-travel-consultant');
        this.durations = this.grabFilters('duration', 'by-duration');
        this.familys = this.grabFilters('family', 'by-family');
        const tab = PaginatedData.getTab();
        const currentPage = 1;

        const data = {
            pageid: this.itemId,
            page: currentPage,
            tab: tab,
            currenturl: location.href.toLowerCase(),
            areas: this.areas,
            tags: this.types,
            grades: this.grades,
            themes: this.themes,
            levels: this.levels,
            activityLevels: this.activityLevels,
            travelConsultants: this.travelConsultants,
            destinations: this.destinations,
            durations: this.durations,
            familys: this.familys,
            filter: PaginatedData.getFilter(),
            q: PaginatedData.getURLqueryString(),
            category: PaginatedData.getOnsiteSearchCategory(),
        };

        this.AddUrlFilterParams(data);

        if (process.env.NODE_ENV === "development") {
            const url = `${this.url}?data=${encodeURIComponent(JSON.stringify(data))}`;
            await this.getDataFromAPI(url, this.method);
        } else {
            const url = `${this.url}?data=${encodeURIComponent(JSON.stringify(data))}`;
            await this.getDataFromAPI(url, this.method);
        }

        if (document.getElementById("multiple-list") !== null) {
            // Number of results functionality
            const pageNumberOSS = document.createElement("div");
            pageNumberOSS.classList.add("page-number-OSS");
            var totalpage = this.numberOfResultsAfterFiltersApplied;
            var currentPageNumber = document.getElementsByClassName("itinerary-list__content__tour-list").length;

            var urlParamsCountry = new URLSearchParams(window.location.search);
            var myParamCountry = urlParamsCountry.get('q');
            var myParamCatagory = urlParamsCountry.get('t');
            if (myParamCatagory.slice(-1) === 's') {
                myParamCatagory = myParamCatagory.slice(0, -1);
            }
            let resultsString = totalpage > 1 ? 'results' : 'result';
            pageNumberOSS.innerHTML = `1 - ${currentPageNumber} of ${totalpage} ${myParamCatagory} ${resultsString} for <span style="text-transform: capitalize">"${myParamCountry}"</span>`;
            var child1 = document.querySelector('.itinerary-list__content')
            document.querySelector('.result-page-tab-content').insertBefore(pageNumberOSS, child1);
            var pageNumberOSS1 = pageNumberOSS.cloneNode(true);
            document.querySelector('#result-page-tab1').appendChild(pageNumberOSS1);
            // Number of results functionality
        }

    }
}

export default MobileFilter;
